var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPharmacist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_1726)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E3E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7621 17.2381C37.7764 14.254 32.9197 14.254 29.9339 17.2381L23.6211 23.5509L30.7884 30.7182C32.2635 29.4898 34.1337 28.7206 36.1988 28.7206C37.3832 28.7206 38.5104 28.9667 39.5359 29.406L40.7621 28.0664C43.7471 25.0814 43.7471 20.2239 40.7621 17.2381Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5945 31.9311L22.4172 24.7539L16.2387 30.9385C13.2538 33.9234 13.2538 38.781 16.2387 41.7668C19.2244 44.7507 24.1378 44.8076 27.1236 41.8234L28.3762 40.5649C27.9368 39.5393 27.6908 38.4122 27.6908 37.2277C27.6908 35.2157 28.4223 33.3892 29.5945 31.9311Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1981 30.4219C32.7308 30.4219 29.9012 33.0243 29.4782 36.3768L42.918 36.3768C42.495 33.0243 39.6654 30.4219 36.1981 30.4219Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.918 38.0786L29.4782 38.0786C29.9012 41.4312 32.7308 44.0336 36.1981 44.0336C39.6654 44.0336 42.495 41.4312 42.918 38.0786Z",
    fill: "#17468C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_1726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacist);
export default __webpack_public_path__ + "static/media/pharmacist.64fb90de5ab85f7bd1ea27381a8165d9.svg";
export { ForwardRef as ReactComponent };